<template>
  <v-container
    grid-list-md
    text-xs-center
  >
    <v-flex
      xs8
      offset-xs2
    >
    </v-flex>
    <v-layout
      row
      v-if='assetDetail'
    >
      <MonitorDetail
        v-if='assetDetail.AssetType==="monitor"'
        :assetDetail='assetDetail'
        :annoy='annoy'
      />
      <ComputerDetail
        v-if='assetDetail.AssetType==="computer"'
        :assetDetail='assetDetail'
        :annoy='annoy'
      />
      <PhoneDetail
        v-if='assetDetail.AssetType==="phone"'
        :assetDetail='assetDetail'
        :annoy='annoy'
      />
    </v-layout>
  </v-container>
</template>

<script>
import MonitorDetail from '../components/MonitorDetail.vue'
import ComputerDetail from '../components/ComputerDetail'
import PhoneDetail from '../components/PhoneDetail'
export default {
  data () {
    return {
      assetDetail: null,
      annoy: true
    }
  },
  components: {
    MonitorDetail,
    ComputerDetail,
    PhoneDetail,
  },
  mounted () {
    const Http = new XMLHttpRequest();
    const url = 'https://us-central1-tech-reuse.cloudfunctions.net/api/assets/' + this.$route.params.id;
    Http.open("GET", url);
    Http.send();
    Http.onreadystatechange = () => {
      if (this.assetDetail === null)
        try {
          this.assetDetail = JSON.parse(Http.responseText)
        }
        catch{
          return
        }
    }
  }
}
</script>

<style>
</style>
